import {Outlet} from 'react-router-dom';
import {StripeProvider} from 'context/stripe';

function Payments() {
  return (
    <StripeProvider>
      <Outlet />
    </StripeProvider>
  );
}

export {Payments};
